// @flow
import React from 'react';

import { COLUMN_1, COMPOSITE_1 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  columns: Array<CMSCard>,
  config: CMSContent,
  id?: string,
};

export function MediaTextVerticalLine({ columns = [], config, id }: Props) {
  if (!columns.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      {columns.length > 1 ? (
        <div className="sm:flex -m-2">
          {columns.map(col => {
            return (
              <div className="p-2 sm:w-1/2" key={col.title}>
                <Card {...mapColToCard({ ...col, config })} layout={COLUMN_1} />
              </div>
            );
          })}
        </div>
      ) : (
        <Card {...mapColToCard({ ...columns[0], config })} layout={COMPOSITE_1} />
      )}
    </SiteContainer>
  );
}
